import React, {useEffect, useState} from "react";
import ReactPlayer from "react-player";
import { useTranslation } from "react-i18next";
import {handleScrollGenerator} from "../helpers/util";

export const About = () => {
  const { t } = useTranslation();
  const [playing, setPlaying] = useState(true);

  useEffect(() => {
    const handleScroll = handleScrollGenerator('player-container', setPlaying);
    window.addEventListener('scroll', handleScroll);
    // Clean up
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <div id="about">
      <div className="container-fluid">
        <div className="row about-prof">
          <div className="col-xs-12 col-md-6 info-text">
            <div className="about-text">
              <h2>{t('about.title')}</h2>
              <p>{t('about.paragraphFirst')}</p>
              <p>{t('about.paragraphSecond')}</p>
            </div>
          </div>
          <div className="col-xs-12 col-md-6 about-img">
            <img src="img/build.jpg" className="img-responsive" alt="build"/>
          </div>
        </div>
        <div className="row about-cat">
          <div className="col-xs-12 col-md-6 about-img">
            <img src="img/cat.png" className="img-responsive" alt="about"/>
          </div>
          <div className="col-xs-12 col-md-6 info-text">
            <div className="about-text">
              <p>{t('about.paragraphActivity')}</p>
              <p>{t('about.paragraphQuality')}</p>
            </div>
          </div>
        </div>
        <div className="row about-service">
          <div className="col-xs-12 col-md-6 info-text">
            <div className="about-text">
              <h2>{t('about.service')}</h2>
              <p>{t('about.paragraphService')}</p>
            </div>
          </div>
          <div className="col-xs-12 col-md-6 about-img">
            <img src="img/about.png" className="img-responsive" alt="about"/>
          </div>
        </div>
        <div className="row">
          <div className="video-container" id="player-container">
            <ReactPlayer
                url="https://www.youtube.com/watch?time_continue=1&v=fkHZCBL181I&embeds_referring_euri=https%3A%2F%2Fprofroad.am%2F&embeds_referring_origin=https%3A%2F%2Fprofroad.am&source_ve_path=Mjg2NjY&feature=emb_logo"
                controls
                width="100%"
                height="100%"
                light={"<img src='/img/bg.png' alt='bg'>" }
                playing={playing}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
